import { render } from "./ConfirmOrderButton.vue?vue&type=template&id=0b453d0c"
import script from "./ConfirmOrderButton.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__